import moment from "moment";
import { useMemo } from "react";
import { graphql, useFragment } from "react-relay";

import type { useFlightDuration_fragment$key } from "__generated__/useFlightDuration_fragment.graphql";

const fragment = graphql`
  fragment useFlightDuration_fragment on Flight {
    takeoff
    landingUtime
    takeoffUtime
  }
`;

type Output = {
  takeoff: moment.Moment;
  landing?: moment.Moment;
  duration?: moment.Duration;
};

export const useFlightDuration = (item: useFlightDuration_fragment$key): Output => {
  const flight = useFragment(fragment, item);

  const [takeoff, landing, duration] = useMemo(() => {
    // Convert from microseconds
    const delta = ((flight.landingUtime || 0) - (flight.takeoffUtime || 0)) / 1000000;
    return [
      moment(flight.takeoff).local(),
      delta > 0 ? moment(flight.takeoff).add(delta, "seconds").local() : undefined,
      delta > 0 ? moment.duration(delta, "seconds") : undefined,
    ];
  }, [flight.takeoff, flight.takeoffUtime, flight.landingUtime]);

  return {
    takeoff,
    landing,
    duration,
  };
};
